import { render, staticRenderFns } from "./reportRourthDetails.vue?vue&type=template&id=5384b480&scoped=true&"
import script from "./reportRourthDetails.vue?vue&type=script&lang=js&"
export * from "./reportRourthDetails.vue?vue&type=script&lang=js&"
import style0 from "./reportRourthDetails.vue?vue&type=style&index=0&id=5384b480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5384b480",
  null
  
)

export default component.exports